import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IRichBlockTaskList, RichBlockActionActivation } from '@pure1/data';
import { RichBlockActionButtonComponent } from '../rich-block-action-button/rich-block-action-button.component';

/**
 * An ordered sequence of steps, rendered as an `<ol>` in declared order.
 *
 * Display only (FR-049): no checkbox, no done state, no interactive state of any kind beyond the
 * optional per-step actions. So there is nothing to persist and nothing to restore on reload.
 */
@Component({
    selector: 'copilot-rich-block-task-list',
    templateUrl: './task-list-block.component.html',
    styleUrl: './task-list-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [RichBlockActionButtonComponent],
})
export class TaskListBlockComponent {
    readonly block = input.required<IRichBlockTaskList>();

    readonly activateAction = output<RichBlockActionActivation>();
}
